export const TrackingEvents = {
  room_entered: 'room_entered',
  interest_selected: 'interest_selected',
  name_entered: 'name_entered',
  child_onboarding_block_completed: 'child_onboarding_block_completed',
  child_onboarding_block_started: 'child_onboarding_block_started',
  object_clicked: 'object_clicked',
  object_close_icon_clicked: 'object_close_icon_clicked',
  object_story_button_clicked: 'object_story_button_clicked',
  introduction_completed: 'introduction_completed',
  navigate_to_journey_back: 'navigate_to_journey_back',
  story_initiated: 'story_initiated',
  story_started: 'story_started',
  story_block_start: 'story_block_start',
  story_block_complete: 'story_block_complete',
  story_completed: 'story_completed',
  story_replayed: 'story_replayed',
  story_saved: 'story_saved',
  chat_response_saved: 'chat_response_saved',
  home_icon_clicked: 'home_icon_clicked',
  journal_saved: 'journal_saved',
  doodle_saved: 'doodle_saved',
  doodle_method_selected: 'doodle_method_selected',
  quest_saved: 'quest_saved',
  bingo_saved: 'bingo_saved',
  calm_corner_exercise_complete: 'calm_corner_exercise_complete',
  calm_corner_feeling_feedback: 'calm_corner_feeling_feedback',
  heart_corner_feeling: 'heart_corner_feeling',
  chat_game_replayed: 'chat_game_replayed',
  child_answers_to_troo: 'child_answers_to_troo',
  child_asks_troo: 'child_asks_troo',
  activity_opened: 'activity_opened'
} as const;
